import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import {openSearch, setSearchResult, updateSearchParams} from "../../redux/action/search_actions";
import {SearchInput} from "./SearchInput";
import {SearchItem} from "../item/SearchItem";
import {Spinner} from "../spinner/Spinner";
import { queryParam } from "../../util/QueryParam";
import { Container } from 'reactstrap';
import {BasicAnimation} from "../animations/BasicAnimation";

class SearchBarContainer extends Component {

  DROPDOWN_ITEMS = 5;

  constructor(props) {
    super(props);

    this.state = {
      result: [],
      selectedIndex: -1
    };


    this.handleSubmit   = this.handleSubmit.bind(this);
    this.productPressed = this.productPressed.bind(this);
    this.onKeyDown      = this.onKeyDown.bind(this);
  }

  handleSubmit(event) {
    const search = event.target.value || this.props.search_str;
    queryParam.changeLocation('/search',[{ key: 'v', value: search }], false);
    this.props.updateSearchParams(search);
    this.props.setSearchResult({ dropdown: [], searchView: this.props.result });
    this.reset();
    this.props.closeNav();
    this.props.closeSearch(event);
    event.preventDefault();
  }

  productPressed(event, result){
    const solution = result.product_categories.find(p => p.parent === 0);

    if(solution !== -1){
      this.props.changeLocation("/solutions/" + solution.slug + "/products/" + result.post_name);
      this.reset();
      this.props.closeNav();
      this.props.closeSearch(event);
      this.props.setSearchResult({ dropdown: [], searchView: [] });
      event.preventDefault();
    }

  }

  componentWillReceiveProps(nextProps){
    if(nextProps.result)
      this.setState({ result: nextProps.result });

    if(nextProps.open !== this.props.open)
      this.setState({
        result: [],
        selectedIndex: -1
      });
  }

  render(){
    if( !this.props.open )
      return null;

    const search_results = this.state.result && this.state.result
      .slice(0,this.DROPDOWN_ITEMS)
      .map( ( result, index ) => {
        return (
          <BasicAnimation duration={400} delay={0}>
          <SearchItem key={index}
                      attributes={{
                        onClick: event => this.productPressed(event, result),
                        className: "pointer"
                      }}
                      title={result.post_title}
                      image={result.thumbnail}
                      active={index === this.state.selectedIndex}/>
          </BasicAnimation>
        );
      });

    return (
      <div className="search-container" onKeyDown={this.onKeyDown}>
        <BasicAnimation duration={200} delay={0}>
        <Container>
          <div className="search-input-container">
            <span className="input-inner obelux-icons" aria-hidden="true">&#xE002;</span>
            <SearchInput testi={"1"}
                         className="search-input"
                         reset={ reset => this.reset = reset }
                         resultPath="dropdown"
                         innerRef={ el => el && el.focus() }/>

            <div className="input-dropdown">
              { !this.props.loading && search_results }
              {
                ( this.state.result &&
                  this.state.result.length > 0 &&
                  !this.props.loading &&
                  this.DROPDOWN_ITEMS < this.state.result.length ) &&
                <div className={"pointer load-more"} onClick={this.handleSubmit}>Load More</div>
              }
              {
                this.props.loading &&
                <div className="spinner-container">
                  <Spinner opts = {
                    {
                      width: 4,
                      color: '#005896'
                    }
                  }/>
                </div>
              }
            </div>
          </div>
        </Container>
        </BasicAnimation>
        <BasicAnimation duration={50} delay={0}>
        <div className="backdrop" onClick={this.props.closeSearch}/>
        </BasicAnimation>
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState){
    if( this.props.open !== prevProps.open ){
      if(this.props.open){
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }

  onKeyDown(event){
    const length = Math.min(this.DROPDOWN_ITEMS,this.state.result.length);

    switch(event.key){
      case 'ArrowUp':
        switch(this.state.selectedIndex){
          case -1:
            this.setState({ selectedIndex: length - 1 });
            break;
          default:
            this.setState({ selectedIndex: ( this.state.selectedIndex - 1 ) % length });
        }
        event.preventDefault();
        break;
      case 'ArrowDown':
        if(this.state.selectedIndex === length - 1 )
          this.setState({ selectedIndex: -1 });
        else
          this.setState({ selectedIndex: ( this.state.selectedIndex + 1 ) % length });

        event.preventDefault();
        break;
      case 'Enter':
        if(this.state.selectedIndex !== -1)
          this.productPressed(event,this.state.result[this.state.selectedIndex]);
        else
          this.handleSubmit(event);
        break;
      default:
    }
  }
}

export const SearchBar = connect(
  state => ({
    open: state.search.open,
    loading: state.search.loading,
    result: state.search.result.dropdown,
    wpapi: state.WPAPI.instance,
    closeNav: state.navbar.close,
    search_str: state.search.value
  }),
  dispatch => ({
    changeLocation: location => dispatch(push(location)),
    closeSearch: (event) => {
      event.preventDefault();
      dispatch(openSearch(false));
    },
    setSearchResult: result => dispatch(setSearchResult(result)),
    updateSearchParams: param => dispatch(updateSearchParams(param))
  })
)(SearchBarContainer);



// WEBPACK FOOTER //
// ./src/components/search-bar/SearchBar.js